import '../styles/Picker.css';
import '../styles/ColorPicker.css';

import React, { useEffect, useState } from 'react';

import ColorPickerDialog from './ColorPickerDialog';
import ColorPickerService from '../services/ColorPickerService';
import Grid from '@mui/material/Unstable_Grid2';
import PickerResetButton from './PickerResetButton';
import { RgbaColor } from '../../content/models/LessonComponentStyle';
import Typography from '@mui/material/Typography';
import { getColorString } from '../../content/services/StyleService';

interface ColorPickerProps {
  color: RgbaColor | string;
  resetButton?: boolean;
  disabled?: boolean;
  isRgba?: boolean;
  onChange: (color: RgbaColor | string) => void;
}

const ColorPickerButton = (props: ColorPickerProps) => {
  const { color, disabled, isRgba } = props;
  const [showColorPickerDialog, setShowColorPickerDialog] = useState(false);
  const [rgbaColor, setRgbaColor] = useState<RgbaColor>(null);

  useEffect(() => {
    if (color) {
      const rgba = isRgba
        ? (color as RgbaColor)
        : ColorPickerService.hexToRgbA(color as string);
      setRgbaColor(rgba);
    }
  }, [color]);

  function handleClick() {
    if (!disabled) {
      setShowColorPickerDialog(true);
    }
  }

  function handleReset() {
    props.onChange(null);
  }

  const handleClose = (rgba?: RgbaColor) => {
    if (rgba) {
      props.onChange(isRgba ? rgba : ColorPickerService.rgbToHex(rgba));
    }
    setShowColorPickerDialog(false);
  };

  const displayHexColor = () => {
    if (color) {
      const result = isRgba
        ? ColorPickerService.rgbToHex(color as RgbaColor)
        : (color as string);
      return ColorPickerService.getColorComponent(result);
    }
  };

  return (
    <>
      <Grid container alignItems="center" spacing={1}>
        <Grid>
          <Typography
            variant="caption"
            className={`color-picker-label ${disabled ? 'disabled' : ''}`}
          >
            {displayHexColor() || 'NOT SET'}
          </Typography>
        </Grid>
        {color && (
          <Grid>
            <Typography
              variant="caption"
              className={`color-picker-label ${disabled ? 'disabled' : ''}`}
            >
              {Math.round(rgbaColor && rgbaColor.a && rgbaColor.a * 100)}%
            </Typography>
          </Grid>
        )}
        <Grid onClick={handleClick}>
          <div
            className={`color-picker-button-round ${
              disabled ? 'disabled' : ''
            }`}
            style={{
              backgroundColor: color
                ? isRgba
                  ? getColorString(color as RgbaColor)
                  : (color as string)
                : '',
              cursor: disabled ? 'default' : 'pointer'
            }}
          ></div>
        </Grid>
        {props.resetButton && (
          <Grid>
            <PickerResetButton
              disabled={disabled || !color}
              onReset={handleReset}
            />
          </Grid>
        )}
      </Grid>
      {showColorPickerDialog && (
        <ColorPickerDialog color={rgbaColor} onClose={handleClose} />
      )}
    </>
  );
};

export default ColorPickerButton;
